import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ticketService, { 
  TICKET_CATEGORIES, 
  TICKET_CATEGORY_LABELS
} from '../services/ticketService';
import './TicketCreate.css';

const TicketCreate = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    category: TICKET_CATEGORIES.TECHNICAL
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title.trim()) {
      setError('请输入工单标题');
      return;
    }
    
    if (!formData.description.trim()) {
      setError('请输入问题描述');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const ticket = await ticketService.createTicket(formData);
      
      // 跳转到工单详情页
      navigate(`/tickets/${ticket.id}`);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/tickets');
  };

  return (
    <div className="ticket-create-container">
      <div className="ticket-create-header">
        <h1>提交工单</h1>
        <p>请详细描述您遇到的问题，我们会尽快为您处理</p>
      </div>

      <div className="ticket-create-form">
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="title">工单标题 <span className="required">*</span></label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
              placeholder="请简要描述问题"
              maxLength={255}
              required
            />
            <div className="form-hint">
              {formData.title.length}/255 字符
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="category">问题分类 <span className="required">*</span></label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleInputChange}
              required
            >
              <option value={TICKET_CATEGORIES.TECHNICAL}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.TECHNICAL]}
              </option>
              <option value={TICKET_CATEGORIES.ACCOUNT}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.ACCOUNT]}
              </option>
              <option value={TICKET_CATEGORIES.PAYMENT}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.PAYMENT]}
              </option>
              <option value={TICKET_CATEGORIES.FEATURE_REQUEST}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.FEATURE_REQUEST]}
              </option>
              <option value={TICKET_CATEGORIES.BUG_REPORT}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.BUG_REPORT]}
              </option>
              <option value={TICKET_CATEGORIES.OTHER}>
                {TICKET_CATEGORY_LABELS[TICKET_CATEGORIES.OTHER]}
              </option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="description">问题描述 <span className="required">*</span></label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="请详细描述您遇到的问题，包括：&#10;1. 问题的具体表现&#10;2. 出现问题的步骤&#10;3. 期望的结果&#10;4. 其他相关信息"
              rows={8}
              required
            />
            <div className="form-hint">
              请尽可能详细地描述问题，这样我们能够更快地为您解决
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              onClick={handleCancel}
              className="btn btn-secondary"
              disabled={loading}
            >
              取消
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? '提交中...' : '提交工单'}
            </button>
          </div>
        </form>
      </div>

      {/* 帮助信息 */}
      <div className="ticket-help">
        <h3>💡 提交工单小贴士</h3>
        <ul>
          <li>请选择正确的问题分类，有助于我们快速分配处理人员</li>
          <li>详细描述问题现象和复现步骤，提高解决效率</li>
          <li>如果是技术问题，请提供相关的错误信息或截图</li>
          <li>我们会根据工单优先级安排处理顺序</li>
          <li>工单提交后，您可以在"我的工单"中查看处理进度</li>
        </ul>
      </div>
    </div>
  );
};

export default TicketCreate;
